import { z } from "zod"

export const payrollProviderOperationStateV1Schema = z.enum([
  "accepted",
  "processing",
  "succeeded",
  "failed",
])

export const payrollSubmissionV1Schema = z
  .object({
    legalEntityId: z.string().uuid(),
    providerCompanyId: z.string().min(1).max(128),
    inputSnapshotId: z.string().uuid(),
    idempotencyKey: z.string().min(8).max(128),
    correlationId: z.string().uuid(),
  })
  .strict()

export const payrollProviderOperationV1Schema = z
  .object({
    operationId: z.string().min(1).max(128),
    state: payrollProviderOperationStateV1Schema,
    providerCorrelationId: z.string().min(1).max(128).nullable(),
    retryAfterSeconds: z.number().int().min(0).max(300).nullable(),
  })
  .strict()

export const verifiedPayrollEventV1Schema = z
  .object({
    eventId: z.string().min(1).max(128),
    eventType: z.string().regex(/^[a-z][a-z0-9_.-]{1,63}$/),
    operationId: z.string().min(1).max(128),
    replayed: z.boolean(),
  })
  .strict()

export type PayrollSubmissionV1 = z.infer<typeof payrollSubmissionV1Schema>
export type PayrollProviderOperationV1 = z.infer<
  typeof payrollProviderOperationV1Schema
>
export type VerifiedPayrollEventV1 = z.infer<
  typeof verifiedPayrollEventV1Schema
>
